const baseUrl = function () {
  let url
    if (process.env.NODE_ENV == 'development') {
      url = ''
    } else {
      // url = 'https://natang-api.lengqidong.com'
      url = 'https://natang-api.sanhaoradio.com'
    }
    return url
}

module.exports = {
  baseUrl: baseUrl()
}
